import { HttpError } from '~/lib/useRequest';
import { useErrorHandler } from '~/hooks/useErrorHandler';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';
import { usePatchApplication } from '~/data/useApplication';

export function usePassScreeningActivity() {
  const { apiError } = useErrorHandler();
  const { completeProcess, application } = useAppProcessing();
  const { patchApplication } = usePatchApplication(application.id);

  function submitPassScreening() {
    return patchApplication({ status: 'READY_FOR_ASSESSMENT' })
      .catch((err) => {
        if (HttpError.of(err).message.includes('invalid status')) {
          apiError('Application is already screened, please refresh the page');
        } else {
          apiError();
        }
        throw err;
      })
      .finally(() => completeProcess());
  }

  return { submitPassScreening };
}
